import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useWorkingTimeStore } from '@nsftx/seven-client-retail-vue-dm'
import { useIntegrator } from '@nsftx/seven-client-retail-vue-integrator'
import { logService } from '@nsftx/seven-client-retail-utils'

const LOG_PREFIX = '[integratorPOSBettingService]'
let workingTimeValidationTimeout: number | undefined

const init = () => {
  handleBettingAvailability()
}

const handleBettingAvailability = () => {
  watchWorkingTimeValidity()
}

const validateBettingAvailability = () => {
  const workingTimeStore = useWorkingTimeStore()
  const { denyBetting, allowBetting } = useIntegrator()
  const { isValid, scheduleTime } = workingTimeStore.isWorkingTimeValid()

  if (!isValid) {
    denyBetting()
    logService.error(`${LOG_PREFIX} Betting is denied.`, {
      code: 'SS_INTEGRATOR_BETTING_DENY_SUCCESS',
    })
    return
  }

  allowBetting()
  logService.debug(`${LOG_PREFIX} Betting is allowed.`, {
    code: 'SS_INTEGRATOR_BETTING_ALLOW_SUCCESS',
  })

  if (workingTimeValidationTimeout) {
    clearTimeout(workingTimeValidationTimeout)
  }

  workingTimeValidationTimeout = window.setTimeout(validateBettingAvailability, scheduleTime)
}

const watchWorkingTimeValidity = () => {
  const workingTimeStore = useWorkingTimeStore()
  const { workingTimeData } = storeToRefs(workingTimeStore)

  watch(
    workingTimeData,
    () => {
      validateBettingAvailability()
    },
    { immediate: true },
  )
}

export default { init }
